import apiRequest from './apiRequest';

export default async function putOrganizationInviteResend(
  organizationID: string,
  inviteID: string,
) {
  return apiRequest<{ resent: true }>(
    'user',
    `/organizations/${encodeURIComponent(organizationID)}/invites/${encodeURIComponent(inviteID)}`,
    { method: 'PUT' },
  );
}
